/** @format */

/* Deprecato, non utilizzare */
const spacing = {
  p0: '0.1rem',
  p1: '.25rem',
  p2: '.5rem',
  p3: '.75rem',
  p4: '1rem',
  p5: '1.25rem',
  p6: '1.5rem',
  pagePadding: {
    p0: '0vw',
    p1: '3.5vw',
    p2: '3.5vw',
    p3: '6vw',
    p4: '15vw'
  }
};

export const valuesSpacing = Object.keys(spacing);

export default spacing;
